import { render, staticRenderFns } from "./feed-processing.vue?vue&type=template&id=4a8010cf&scoped=true"
import script from "./feed-processing.vue?vue&type=script&lang=js"
export * from "./feed-processing.vue?vue&type=script&lang=js"
import style0 from "./feed-processing.vue?vue&type=style&index=0&id=4a8010cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8010cf",
  null
  
)

export default component.exports